import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import { Mutex } from 'async-mutex'
import Cookies from 'universal-cookie'
import { RootState } from './store'
import { clearToken, setToken } from './authSlice'

// create a new mutex
const mutex = new Mutex()
export const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_BASE_URI,
  prepareHeaders: (headers, api) => {
    let token = (api.getState() as RootState).auth.token
    if (!token) {
      token = localStorage.getItem('echoesToken') || undefined
    }
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
      const cookies = new Cookies()
      const cookieToken = cookies.get('token')
      if (cookieToken !== token) {
        cookies.set('token', token)
      }
    } else {
      console.debug('No token in redux')
    }
    return headers
  },
  //credentials: 'include'
})
export const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError,
  {},
  { response?: { headers: { get: (header: string) => string | null } } }
> = async (args, api, extraOptions) => {
  // wait until the mutex is available without locking it
  await mutex.waitForUnlock()
  let result = await baseQuery(args, api, extraOptions)
  if (result.error && result.error.status === 401) {
    // checking whether the mutex is locked
    if (!mutex.isLocked()) {
      const release = await mutex.acquire()
      try {
        const refreshResult = await baseQuery(
          '/refreshToken',
          api,
          extraOptions
        )
        if (refreshResult.data) {
          api.dispatch(setToken(refreshResult.data))
          // retry the initial query
          result = await baseQuery(args, api, extraOptions)
        } else {
          api.dispatch(clearToken())
        }
      } finally {
        // release must be called once the mutex should be released again.
        release()
      }
    } else {
      // wait until the mutex is available without locking it
      await mutex.waitForUnlock()
      result = await baseQuery(args, api, extraOptions)
    }
  }
  return result
}